import { PlycaDataService } from '../../../services/plyca.service';
import {
  FileDetailsDTO,
  SignatureDTO,
  I18nData,
  SignatureValidationCode
} from '../../api/plyca-dtos';
import {
  Component,
  AfterContentInit,
  OnInit,
  ElementRef,
  OnDestroy
} from '@angular/core';

import { ServiceLocator } from './../../ServiceLocator';
import { ActivatedRoute } from '@angular/router';
import { SignatureService } from '../../../services/signature.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from '../../../../node_modules/rxjs';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { finalize, switchMap } from 'rxjs/operators';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { SignatureUtils } from '../../../services/signature.utils';

export class ViewSignDTOModal {
  public signature: SignatureDTO;
  public file: FileDetailsDTO;
  public title: I18nData;
  public additionalMsg: I18nData;
  public helpService: HelpService;


  constructor(
    public signItemParameter: SignatureDTO,
    public fileParameter: FileDetailsDTO,
    title?: I18nData,
    additionalMsg?: I18nData
  ) {

    console.log('signItemParameter', signItemParameter);
    this.signature = signItemParameter;
    this.file = fileParameter;
    this.additionalMsg = additionalMsg;
    this.title = title;
    this.helpService = ServiceLocator.injector.get(HelpService);
  }
}
@Component({
  selector: 'validateSignDocument',
  templateUrl: 'validateSignDocument.template.html',
  styles: ['dt {width:auto;white-space:nowrap;}']
})
export class validateSignDocumentComponent extends BaseComponent implements OnInit, AfterContentInit, OnDestroy {
  private route: ActivatedRoute;
  //title: string;
  additionalMsg: string;
  signId: 'Sin Información';
  signature: SignatureDTO;
  file: FileDetailsDTO;
  // documentService: DocumentService;
  validationResultSignature: SignatureValidationCode;
  certificateMessages: string[];
  loadSing: boolean;
  signatureService: SignatureService;
  translateService: TranslateService;
  plycaService: PlycaDataService;
  windowHash: string;
  tagsParent: string[] = [];

  askUser = false;


  public SignatureValidationCode = SignatureValidationCode;

  constructor(public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService,
    private focusTrap: FocusTrapFactory,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private signatureUtils: SignatureUtils,
    private elem: ElementRef) {

    super();
    this.route = ServiceLocator.injector.get(ActivatedRoute);
    this.signatureService = ServiceLocator.injector.get(SignatureService);
    this.translateService = ServiceLocator.injector.get(TranslateService);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.route.params.subscribe(params => {
      this.signId = params['id'];
    });
    console.log('constructor');
    this.signature = dialogConfig['item'].signItemParameter;
    this.file = dialogConfig['item'].file;

    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.VALIDATE_SIGN)
        }
      )));
    let i18nMsg = dialogConfig['titladditionalMsge'];
    if (i18nMsg) {
      this.subscribe(this.translateService.get(i18nMsg.messageKey, i18nMsg.messageParams),
        translation => (this.additionalMsg = translation));
    }

    if (dialogConfig['askUser'] !== null) {
      this.askUser = dialogConfig['askUser'];
    }
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);

        this.dialogConfig = null;
        super.ngOnDestroy();
      })));
  }

  isSingLoad(): boolean {
    return this.loadSing;
  }

  isDetailCertificateLoad(): boolean {
    return this.signature.verification.certificate != null;
  }
  load(): void {
    this.waitService.startWaiting();

    this.subscribe(this.getSignatureDetail(this.signature)
      .pipe(finalize(() => {
        this.focusTrap.create(
          this.elem.nativeElement).focusLastTabbableElementWhenReady()
          .then(focussed => {
            console.log('**** Foco en -> ' + document.activeElement)
          });
        this.waitService.cancelWaiting();
      })),
      (param: SignatureDTO) => {
        this.loadSing = true;
        if (this.signature)
            this.signature.verification = param.verification;        
        this.signature = param;
        this.validationResultSignature = this.signatureUtils.validateSignature(
          this.signature
        );
        this.certificateMessages = this.signature.verification.certificate.validationMessages;
      },
      err => {
        console.log('Error al obtener el detalle de la firma');
        console.log(err);
      }
    );
  }

  public getSignatureDetail(signature: SignatureDTO): Observable<SignatureDTO> {
    console.log('getSignatureDetail');
    let sign: SignatureDTO;
    return this.plycaService.getSignatureDetail(signature);
  }

  ngOnInit(): void {
    this.load();
  }





  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();

    this.headerActionsService.clearWindowActions(this.windowHash);

    if (this.askUser) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'ValidateSignDocument.acceptDocument',
        'fas fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ), success => {
        this.ref.close(true);
      });

      this.subscribe(this.headerActionsService.addWindowAction(
        'ValidateSignDocument.rejectDocument',
        'fas fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ), success => {
        this.ref.close(false);
      });
    } else {

      this.subscribe(this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ), success => {
        this.ref.close();
      });
    }
    this.headerActionsService.setModalDescription(this.askUser ? 'Se han encontrado problemas con la firma, ¿desea anexar el documento igualmente?' : null);


  }

}
